module.exports = __webpack_public_path__ + "static/img/etretat.9180bcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/etretat.jpg
// module id = w1oR
// module chunks = 1